// @ts-nocheck
import { withProduct } from "@insite/client-framework/Components/ProductContext";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Button from "@insite/mobius/Button";
import Mail from "@insite/mobius/Icons/Mail";
import { Icon, Link, Typography } from "@insite/mobius/index";
import { useToaster } from "@insite/mobius/Toast/ToasterContext";
import getColor from "@insite/mobius/utilities/getColor";
import feedbackService from "@store/Framework/Services/ProductFeedBackService";
import useProductContext from "@store/Framework/Store/Data/Products/ProductsHooks/useProductContext";
import ProductFeedbackModal from "@store/Library/Widgets/ProductDetailFeedback/ProductFeedbackModal";
import { getMediaQuery } from "@toolkit/Framework/Common/Utilities/mediaQueries";
import React, { useEffect } from "react";
import styled, { css } from "styled-components";

const mobileQuery = getMediaQuery({ option: "only", first: true, min: 0, max: 480, last: false });
const Container = styled.div`
    display: flex;
    width: 100%;
    padding: 1.25rem;
    justify-content: flex-end;
    ${mobileQuery} {
        justify-content: center;
    }
`;

const StyledButton = styled(Button)`
    background: transparent;
    border: none;
    padding: 0;
    :hover {
        background: transparent;
        border: none;
        text-decoration: underline;
    }
    font-weight: bold;
    margin-left: 4px;
    color: ${getColor("primary")} !important;
    text-align: left;
`;

const StyledButtonText = styled(Typography)`
    margin-left: 4px;
`;

const ProductFeedbackButton: React.FC = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const [website, setWebsite] = React.useState("");
    const toast = useToaster();
    // window object doesn't exist on the server useEffect is only executed on the client
    useEffect(() => {
        if (window && window.location.href !== website) {
            setWebsite(window.location.href);
        }
    });
    const handleModalClick = () => {
        setIsModalOpen(true);
    };

    const product = useProductContext();

    const handleSubmit = async (reportedBy: string, comment: string) => {
        try {
            const response = await feedbackService({
                reportedBy,
                comment,
                sku: product.product.productNumber,
                reportedURL: website,
            });
            toast.addToast({
                messageType: "success",
                body: translate("Thank you for your feedback!"),
            });
        } catch (error) {
            toast.addToast({
                messageType: "warning",
                body: translate("There was an error submitting your feedback. Please try again later."),
            });
        }
    };

    return (
        <Container>
            <StyledButton onClick={handleModalClick}>
                <Icon src={Mail} size={14} />
                <StyledButtonText>{translate("Report Incorrect Information")}</StyledButtonText>
            </StyledButton>
            <ProductFeedbackModal
                isModalOpen={isModalOpen}
                setIsModalOpen={setIsModalOpen}
                handleSubmit={handleSubmit}
            />
        </Container>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductFeedbackButton),
    definition: {
        displayName: "Product Feedback Button",
        group: "Product Details",
    },
};

export default widgetModule;
